'use client';

import Link from 'next/link';
import Image from 'next/image';
import { logos } from '@/shared/assets/images';
import { COMPANY } from '@voley/shared-types/constants';
import { BRAND_BLUE } from '@voley/shared-types/constants';

export default function JoinAgencyPage() {
  const brandBlue = BRAND_BLUE;

  return (
    <div
      data-testid="onboarding-join-agency-page"
      className="min-h-screen flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8"
      style={{ backgroundColor: '#ffffff' }}
    >
      {/* Subtle gradient background */}
      <div
        className="fixed inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse at top right, rgba(53, 129, 207, 0.04) 0%, transparent 50%), radial-gradient(ellipse at bottom left, rgba(53, 129, 207, 0.03) 0%, transparent 50%)',
        }}
      />

      {/* Main content container */}
      <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-gray-100 relative z-10 p-5 sm:p-8">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <Link href="/home">
            <Image
              src={logos.ballOnly}
              alt="Voley"
              width={52}
              height={52}
              className="h-12 w-12 md:hidden"
              priority
            />
            <Image
              src={logos.voleyT}
              alt="Voley"
              width={120}
              height={28}
              className="hidden md:inline h-8 w-auto"
              priority
            />
          </Link>
        </div>

        {/* Header */}
        <div className="mb-6 text-center">
          <h2
            className="text-2xl font-semibold tracking-tight"
            style={{ color: '#111827' }}
          >
            Join Your Agency
          </h2>
          <p
            className="mt-2 text-base"
            style={{ color: '#6B7280' }}
          >
            You need an invitation to join an existing agency
          </p>
        </div>

        {/* Steps */}
        <div className="space-y-4 mb-6">
          <div className="flex items-start">
            <span
              className="flex-shrink-0 h-7 w-7 rounded-full flex items-center justify-center text-white text-sm font-medium"
              style={{ backgroundColor: brandBlue }}
            >
              1
            </span>
            <div className="ml-3">
              <p className="text-sm font-medium" style={{ color: '#111827' }}>Contact your agency administrator</p>
              <p className="text-xs mt-0.5" style={{ color: '#6B7280' }}>
                Ask them to add you to your agency&apos;s Voley account
              </p>
            </div>
          </div>

          <div className="flex items-start">
            <span
              className="flex-shrink-0 h-7 w-7 rounded-full flex items-center justify-center text-white text-sm font-medium"
              style={{ backgroundColor: brandBlue }}
            >
              2
            </span>
            <div className="ml-3">
              <p className="text-sm font-medium" style={{ color: '#111827' }}>Check your email</p>
              <p className="text-xs mt-0.5" style={{ color: '#6B7280' }}>
                You&apos;ll receive an invitation with a unique link
              </p>
            </div>
          </div>

          <div className="flex items-start">
            <span
              className="flex-shrink-0 h-7 w-7 rounded-full flex items-center justify-center text-white text-sm font-medium"
              style={{ backgroundColor: brandBlue }}
            >
              3
            </span>
            <div className="ml-3">
              <p className="text-sm font-medium" style={{ color: '#111827' }}>Click the invitation link</p>
              <p className="text-xs mt-0.5" style={{ color: '#6B7280' }}>
                Create your account and join your agency
              </p>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="space-y-3">
          <Link
            href="/login"
            className="block w-full px-6 py-3 rounded-full font-medium text-white text-center transition-all duration-200"
            style={{
              backgroundColor: brandBlue,
              boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)'
            }}
          >
            I already have an account
          </Link>

          <Link
            href="/get-started"
            className="block w-full px-6 py-3 rounded-full font-medium text-center transition-all duration-200"
            style={{
              backgroundColor: '#ffffff',
              border: '1px solid #E5E7EB',
              color: '#374151'
            }}
          >
            Back to options
          </Link>
        </div>

        {/* Footer note */}
        <div className="mt-6 text-center">
          <p className="text-sm" style={{ color: '#6B7280' }}>
            Are you an agency owner?{' '}
            <Link href="/signup" className="font-medium hover:underline" style={{ color: brandBlue }}>
              Create a new agency
            </Link>
          </p>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 text-center relative z-10">
        <p className="text-sm text-gray-400">
          {COMPANY.copyrightNotice}
        </p>
      </div>
    </div>
  );
}
